module.exports = __webpack_public_path__ + "img/NC.55df0a2e.svg";